export const MEMBERSHIP_ORIGIN = "https://membership.aheadhealth.com";

export const MEMBERSHIP_QUIZ_URL = `${MEMBERSHIP_ORIGIN}/join/quiz/1`;

// Point straight at the resolved signup page. Hitting the bare origin
// (`/?locale=…`) costs two server-side redirect hops on membership's side
// (`/` → `/join` → `/join/membership-plan`), each a full round trip the
// client waits through before the page renders. The hops only carry the
// locale param through unchanged, so linking the destination directly skips
// them with no behavioural difference. This is both the click target and the
// prefetch target, so the prefetched document matches the navigation exactly.
export const membershipSignupUrl = (locale: string) =>
  `${MEMBERSHIP_ORIGIN}/join/membership-plan?locale=${locale}`;

const prefetched = new Set<string>();

const prefetchDocument = (url: string) => {
  if (prefetched.has(url)) return;
  prefetched.add(url);

  const link = document.createElement("link");
  link.rel = "prefetch";
  link.as = "document";
  link.href = url;
  document.head.appendChild(link);
};

/** Warm membership onboarding pages while the product-step CTAs are visible. */
export const prefetchMembershipPages = (locale: string) => {
  prefetchDocument(membershipSignupUrl(locale));
  prefetchDocument(MEMBERSHIP_QUIZ_URL);
};
